<script setup>
import Modal from "@/components/Modal.vue";
import { post } from "@/libs/axios.js";

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false,
    },
    url: {
        type: String,
        default: "",
    },
});

const emit = defineEmits(["close"]);

async function impersonate() {
    const res = await post("/ajax/impersonate");

    if (res.data.success) {
        window.onbeforeunload = null;
        window.location.href = props.url;
    }
}
</script>
<template>
    <Modal
        v-if="props.showModal"
        :show-modal="props.showModal"
        :show-submit-button="false"
        modal-dialog-class="modal-md"
        :simple-header="true"
        @submit-modal="emit('close')"
        @close-modal="emit('close')"
    >
        <div class="mt-3">You cannot perform this action as an admin user</div>
        <div class="mt-3">
            Please <span @click="impersonate">Impersonate User</span> to make these changes.
        </div>
    </Modal>
</template>
<style scoped>
span {
    text-decoration: underline;
    cursor: pointer;
}
</style>
